import PlacedOrder from '@/pages/PlacedOrder'

export default {
    path: '',
    component: PlacedOrder,
    children: [
        {
            path: '/placed/order/:ref',
            name: 'Placed Order',
            component: PlacedOrder,
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/placedorder.js